let simpleModel = {
    temperatureMSL: 15,
    wind: {
        heading: 0,
        speed: 0
    },
    setTemperatureMSL: function(temperature) {
        this.temperatureMSL = temperature;
    },
    setWind: function(heading, speed) {
        this.wind = {
            heading: heading,
            speed: speed
        };
    }
}

export function setMSLTemperature(temperature) {
    simpleModel.setTemperatureMSL(temperature);
}

export function setWind(heading, speed) {
    simpleModel.setWind(heading, speed);
}

export function getTemperature(altitude) {
    return simpleModel.temperatureMSL - (altitude / 1000) * 1.98;
}

export function getWind() {
    return {...simpleModel.wind};
}